import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState } from "react";
import { Alert, Button, Col, Form, Input, Row, Spin } from "antd";
import axios from "axios";
import { axiosErrorHandler } from "../../../swzutils";
import { KeyOutlined } from "@ant-design/icons";
const TOTPProvisionForm = ({ onCompleted }) => {
    const [loading, setLoading] = useState(false);
    const [errorMessage, setErrorMessage] = useState(null);
    const [form] = Form.useForm();
    const onError = (errMsge) => {
        setLoading(false);
        setErrorMessage(errMsge);
    };
    const provisionMFA = (formValues) => {
        setLoading(true);
        axios.post('/admin/v1/users/me/multi-factor-auth', {
            "password": formValues.currentPassword
        }).then((response) => {
            form.setFieldsValue({
                "password": "",
            });
            setLoading(false);
            setErrorMessage(null);
            onCompleted(response.data.secret, response.data.url);
        }).catch((error) => {
            if (error.response.status === 403) {
                setErrorMessage('Password incorrect');
            }
            else {
                // @ts-ignore
                axiosErrorHandler(error, onError);
            }
        }).finally(() => {
            setLoading(false);
        });
    };
    return (_jsxs(Spin, { spinning: loading, children: [_jsx("br", {}), _jsxs(Form, { layout: "vertical", form: form, onFinish: provisionMFA, children: [_jsx(Row, { justify: "center", children: _jsxs(Col, { xl: 18, children: [_jsxs("p", { className: "text-center", children: ["Before you begin ensure you have an Authenticator like ", _jsx("a", { href: "https://play.google.com/store/apps/details?id=com.google.android.apps.authenticator2", target: "_blank", children: "Google Authenticator" }), " app installed on your phone"] }), errorMessage &&
                                    _jsx(Alert, { style: { marginBottom: 30 }, title: "Multi-factor authentication setup failed", description: errorMessage, type: "error", showIcon: true }), _jsx(Form.Item, { name: "currentPassword", label: "Current Password", rules: [
                                        { required: true, message: 'Please input your current password.' }
                                    ], children: _jsx(Input.Password, { prefix: _jsx(KeyOutlined, {}), type: "password", autoComplete: "new-password", placeholder: "Current Password" }) })] }) }), _jsx(Row, { justify: "end", children: _jsx(Button, { type: "primary", htmlType: "submit", size: "large", className: "pull-right", children: "Setup" }) })] })] }));
};
export default TOTPProvisionForm;
